import React from "react";
import { LettersOrders } from "./lettersOrders";
import MainPageDialog from "../../components/dialog";

export const LetterOrderDialog = ({
  letterOrderDialog,
  setLetterOrderDialog,
  attachedFiles,
  setAttachedFiles,
}) => {
  return (
    <>
      {letterOrderDialog ? (
        <MainPageDialog
          title="Letters/Orders"
          footer={false}
          onCancelHandler={() => setLetterOrderDialog(false)}
          component={
            // <AdvanceDirective />
            <LettersOrders
              attachedFiles={attachedFiles}
              setAttachedFiles={setAttachedFiles}
              letterOrderDialog={letterOrderDialog}
              setLetterOrderDialog={setLetterOrderDialog}
            />
          }
        ></MainPageDialog>
      ) : (
        ""
      )}
    </>
  );
};
